import { emailRegexpTest } from 'roomi/utils';
import messages from './forgot-form.text';

const validate = ({ username }, { intl: { formatMessage } }) => {
  const errors = {};
  if (!username) errors.username = formatMessage(messages.missingEmail);
  if (username && !emailRegexpTest(username))
    errors.username = formatMessage(messages.invalidEmail);
  return errors;
};

export default validate;
